import {AuthRequestType, IRefreshTokenRequest} from '@core/api/data-access';
import {environment} from '@shared-types';
import {BE} from '@utils';

import BESchema = BE.BESchema;
import BEProp = BE.BEProp;

@BESchema()
export class RefreshLoginRequestModel implements IRefreshTokenRequest {
	@BEProp() readonly type: AuthRequestType = AuthRequestType.RefreshToken;
	@BEProp() company: string = environment.company;
	@BEProp() accessToken: string;
	@BEProp() refreshToken: string;

	constructor(init?: Partial<RefreshLoginRequestModel>) {
		if (init) Object.assign(this, init);
	}

	public isValid(): boolean {
		return !!this.accessToken && !!this.refreshToken;
	}
}
